import Sentry from "@similarweb/sentry-logger";

import { swSettings } from "app/common/services/swSettings";

import type { IComponentMonitorAndProtectConfig } from "./component-config.types";

const MonitorAndProtectConfigID = "MonitorAndProtectMaster";
export const DEFAULT_MAX_EXCEL_ROWS = 50000;

type SWSettings = {
    settings?: {
        components?: {
            MonitorAndProtectMaster?: IComponentMonitorAndProtectConfig;
        };
    };
};

export function getMonitorAndProtectConfig(): IComponentMonitorAndProtectConfig {
    const sourceConfig: undefined | IComponentMonitorAndProtectConfig = (window.similarweb as SWSettings)?.settings
        ?.components?.MonitorAndProtectMaster;

    const currentComponentFromSettings = swSettings.getCurrentComponent() as
        | undefined
        | IComponentMonitorAndProtectConfig;

    const isConfigMissing = !sourceConfig && !currentComponentFromSettings;

    if (isConfigMissing) {
        const errorMessage = new Error(
            `MonitorAndProtect config is missing. Please check if the component is registered in the settings or if the config ID is correct.`,
        );
        Sentry.errorTracker({
            e: errorMessage,
            includeCustomFingerPrint: ["MonitorAndProtectConfigMissing"],
            message: errorMessage.message,
            level: "fatal",
            params: {
                extra: {
                    component: "MonitorAndProtect",
                    configId: MonitorAndProtectConfigID,
                },
            },
        });
        throw errorMessage;
    }

    return sourceConfig ?? currentComponentFromSettings;
}
